import { COLORS } from '../../../constants/colors';

const NUM_OF_COLS = 10;

enum LOCAL_COLORS {
  BLACK = 'black',
}

export const COLUMN_CHART_COLORS = {
  ...COLORS,
  ...LOCAL_COLORS,
};

export const ColumnsChart = ({
  index,
  className = 'h-7',
  color,
  onClick,
  disabled,
}: {
  index: number;
  className?: string;
  color: COLORS | LOCAL_COLORS;
  onClick?: (columnNumber: number) => void;
  disabled?: boolean;
}) => (
  <div
    className={`flex relative ${className} gap-1 ${
      disabled && 'pointer-events-none'
    }`}
  >
    {[...Array(NUM_OF_COLS)].map((_, i) => (
      <div
        key={i}
        onClick={() => onClick?.(i + 1)}
        className={`
          box-content
          relative
          border
          border-transparent
          min-w-4
          flex-grow-1
          h-full
          rounded-md
          pr-1
          bg-${i < index ? color : 'gradient-to-br'}
          from-grey-30
          to-grey-30
          dark:from-grey-30
          dark:to-grey-50
          ${onClick && 'hover:border hover:border-grey-10 cursor-pointer'}
        `}
      >
        <div
          className={`
            absolute
            top-0
            left-0
            right-0
            bottom-0
            bg-gradient-to-b
            from-grey-30
            to-grey-50
            ${i < index ? 'opacity-20' : 'opacity-70'}
            rounded-md
          `}
        />
      </div>
    ))}
  </div>
);
